<template>
  <div class="general-wrapper">
    <Header :parent="$route.query.from">
      <template #title>
        <h4 class="qrw-heading-xs">
          {{ $t("tables.payments_history") }}
        </h4>
      </template>
    </Header>

    <IQOSTable
      :cols="[
        {
          title: $t('subscription.transactions.number'),
          key: 'banking_id',
        },
        {
          title: $t('subscription.transactions.date'),
          key: 'created_at',
          date: true
        },
        {
          title: $t('subscription.transactions.time'),
          key: 'created_at',
          time: true,
          width: 80
        },
        {
          title: $t('subscription.transactions.system'),
          key: 'system',
          renderer: formatSystemName,
        },
        {
          title: $t('subscription.transactions.method'),
          key: 'pay_method',
          renderer: (t) => `${t.card_type.toUpperCase()} ${t.card_mask}`,
        },
        {
          title: $t('subscription.transactions.sum'),
          key: 'amount_usd',
          default: '0',
          unit: '$',
          width: 120
        },
        {
          title: $t('subscription.transactions.status'),
          key: 'status',
        },
      ]"
      :rows="transactions"
    >
      <template #col-status="slotProps">
        <span class="green-5-color" v-if="slotProps.rowItem.status == 'success'">{{
          $t("subscription.transactions.success")
        }}</span>
        <span class="v1-grey-10-color" v-else-if="slotProps.rowItem.status == 'reversed'">{{
          $t("subscription.transactions.reversed")
        }}</span>
        <span class="red-4-color" v-else>{{
          $t("subscription.transactions.error")
        }}</span>
      </template>
    </IQOSTable>
  </div>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import SubscriptionAPI from "@/api/subscription";

import ModeIcon from "@/components/ModeIcon.vue";

export default {
  data() {
    return {
      transactions: [],
    };
  },

  components: {
    IQOS,
  },
  methods: {
    formatSystemName({ mode }) {
      return {
        inside: "INSIDE",
        preorder: "TAKEAWAY",
        delivery: "DELIVERY",
        reserve: "RESERVE",
        pro: "PRO",
      }[mode];
    },
  },
  mounted() {
    SubscriptionAPI.getTransactions(this.$store.state.cafe._id)
      .then((data) => {
        this.transactions = data.transactions;
      })
      .catch((error) => {
        this.$store.dispatch("showError", "subscription_error");
      });
  },
};
</script>

<style scoped>
.subscribtions-table {
  width: 100%;
  border-collapse: none;
}
.subscribtions-table thead {
  background: rgba(70, 70, 70, 0.9);
  backdrop-filter: blur(7px);
}
.subscribtions-table thead th {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888vh;
  color: #ededed;
  width: 14.222222222222221vh;
  text-align: center;
  padding: 1.1111vh 1.6666666666666667vh;
}
.subscribtions-table tbody tr {
  color: #1d1d1b;
}
.subscribtions-table tbody td {
  text-align: center;
  font-size: 2.2222222222222223vh;
  line-height: 2.5555555555555554vh;
  padding: 0.6666666666666666vh 0;
}
.success {
  color: #129b81;
}
.exeption {
  color: #e2223b;
}
</style>
